export default __webpack_public_path__ + "static/media/GoalImg17.a59f0fd8.png";